import { PhonicsActivityTypeMode } from '@/api/types';
import { Stage } from '@/components/lessonKit';
import {
  ACTIVITY_TYPE_READING_LISTENING_IDENTIFIER,
  ACTIVITY_TYPE_READING_ORAL_BLENDING_IDENTIFIER,
  ACTIVITY_TYPE_READING_NEW_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_REVIEW_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_FOCUS_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_MANIPULATING_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_TRICKY_WORDS_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_FLICKING_FINGERS_IDENTIFIER,
} from './types';

/**
 * Maps a phonics activity to its pedagogical stage colour, per the v4 design
 * system's "one activity = one colour" rule (see the colour guidelines):
 *
 * - practice (purple)  — modelling sounds: new/review/focus/manipulating sounds
 * - select   (coral)   — listening / auditory discrimination
 * - progress (teal)    — blending & segmenting
 * - write    (green)   — the spelling (LEARN) half
 * - action   (orange)  — everything else / reward / default
 */
/**
 * Activities rendered in the clay (Play-Doh) app theme rather than the v4
 * stage-colour smartboard look. Review Sounds is the first "Say the Sound"
 * screen redesigned to clay (gold field, cream flashcard, green clay controls).
 */
export const isClayActivity = (identifier: string): boolean =>
  identifier === ACTIVITY_TYPE_READING_REVIEW_SOUNDS_IDENTIFIER ||
  identifier === ACTIVITY_TYPE_READING_FOCUS_SOUNDS_IDENTIFIER;

export const getActivityStage = (
  identifier: string,
  mode: PhonicsActivityTypeMode,
): Stage => {
  switch (identifier) {
    case ACTIVITY_TYPE_READING_LISTENING_IDENTIFIER:
      return 'select';
    case ACTIVITY_TYPE_READING_ORAL_BLENDING_IDENTIFIER:
    case ACTIVITY_TYPE_SPELLING_FLICKING_FINGERS_IDENTIFIER:
      return 'progress';
    case ACTIVITY_TYPE_READING_NEW_SOUNDS_IDENTIFIER:
    case ACTIVITY_TYPE_READING_REVIEW_SOUNDS_IDENTIFIER:
    case ACTIVITY_TYPE_READING_FOCUS_SOUNDS_IDENTIFIER:
    case ACTIVITY_TYPE_READING_MANIPULATING_SOUNDS_IDENTIFIER:
    case ACTIVITY_TYPE_READING_TRICKY_WORDS_IDENTIFIER:
      return 'practice';
    default:
      return mode === PhonicsActivityTypeMode.LEARN ? 'write' : 'action';
  }
};
